/**
 * Google Analytics Consent Management
 * Simple utility for managing analytics consent
 */

// Cookie utility functions
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// Google Analytics ID
const GA_MEASUREMENT_ID = 'G-5TCTQ6GMPR';

// Initialize dataLayer
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

// Set default consent state to denied
function initializeConsent() {
  gtag('consent', 'default', {
    'analytics_storage': 'denied'
  });
  
  // Check if consent was already given
  const consentGiven = getCookie('analytics_consent');
  if (consentGiven === 'true') {
    // If consent was already given, update consent state
    gtag('consent', 'update', {
      'analytics_storage': 'granted'
    });
    
    // Load Google Analytics
    loadGoogleAnalytics();
  }
  
  // Show banner and add event listeners when DOM is loaded
  window.addEventListener('DOMContentLoaded', function() {
    // Show banner if consent status unknown
    if (consentGiven === null) {
      document.getElementById('consent-banner').style.display = 'block';
    }
    
    // Add event listeners to consent buttons
    const acceptButton = document.getElementById('accept-analytics');
    const rejectButton = document.getElementById('reject-analytics');
    
    if (acceptButton) {
      acceptButton.addEventListener('click', acceptAnalytics);
    }
    
    if (rejectButton) {
      rejectButton.addEventListener('click', rejectAnalytics);
    }
  });
}

// Load Google Analytics script
function loadGoogleAnalytics() {
  if (!document.querySelector(`script[src="https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
    var gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gaScript);
    
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);
  }
}

// Accept analytics and start tracking
function acceptAnalytics() {
  // Update consent state
  gtag('consent', 'update', {
    'analytics_storage': 'granted'
  });
  
  // Save consent preference
  setCookie('analytics_consent', 'true', 365); // Store for 1 year
  
  // Load Google Analytics
  loadGoogleAnalytics();
  
  // Hide consent banner
  document.getElementById('consent-banner').style.display = 'none';
}

// Reject analytics
function rejectAnalytics() {
  // Save rejection preference
  setCookie('analytics_consent', 'false', 365);
  
  // Hide consent banner
  document.getElementById('consent-banner').style.display = 'none';
}

// Export functions for use in HTML by attaching to window
// This is necessary when using type="module" since modules have their own scope
window.acceptAnalytics = acceptAnalytics;
window.rejectAnalytics = rejectAnalytics;

// Initialize when script loads
initializeConsent();

// For module exports if needed
export { acceptAnalytics, rejectAnalytics, initializeConsent };
